import EZO	from "./circuits/ezo.js";

class TemperatureSensor extends EZO {
  constructor(p) {
    super(0x66);

    this.id = "";
    this.status = "uninitialized";
  }
  async initialize() {
    try {
      await super.initialize();
      this.id = await this.command("i");
      this.status = "ok";
    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }
  update() {
    return( new Promise(function(resolve, reject) {
      this.command("R").then(function(result) {
        this.value = Math.round(parseFloat(result)*100)/100;
        resolve(this.value);
      }.bind(this)).catch(function(result) {
        reject(result);
      }.bind(this));
    }.bind(this)) );
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      value: this.value
    });
  }
}

export default TemperatureSensor;